import * as React from "react"

const Info = ({ color = "#566162", ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={21} height={21} fill="none" {...props}>
    <path
      fill={color}
      d="M3.053 17.193A10 10 0 1 1 16.947 2.807 10 10 0 0 1 3.053 17.193Zm12.73-1.41a8.004 8.004 0 1 0-11.32-11.32 8.004 8.004 0 0 0 11.32 11.32Zm-6.66-4.66v-2h2v6h-2v-4Zm0-6h2v2h-2v-2Z"
    />
  </svg>
)
export default Info
